export const config = {
    "label": "prod",
    "defaultConfigUrl": "https://quai-md-km-default-rtdb.firebaseio.com/_frontend/default.json",
    "configUrl": "https://quai-md-km-default-rtdb.firebaseio.com/_frontend/km.json"
};
